import { queryOptions } from '@tanstack/react-query';

import { SuccessResponse } from 'src/apis/dto/common';
import { DTOMainPage } from 'src/apis/dto/DTOMainPage';
import useLogin from 'src/hooks/useLogin';
import { ShopApiList } from 'src/stores/shop/apis';
import { client } from 'src/utils/api';

export const useShopPageQueryOptions = () => {
  const { isLogin } = useLogin();

  return queryOptions<DTOMainPage>({
    queryKey: [ShopApiList.GetShopPage],
    async queryFn() {
      const response = await client.get<SuccessResponse<DTOMainPage>>(ShopApiList.GetShopPage);

      return response.data.result;
    },
    gcTime: Infinity,
    staleTime: Infinity,
    refetchOnMount: 'always',
    enabled: isLogin,
  });
};
